// extracted by mini-css-extract-plugin
export default {"section":"_3jO82j2e","hide":"_18gdmf0e"};